import { render, staticRenderFns } from "./ContactWidget.vue?vue&type=template&id=631f0fdd&"
import script from "./ContactWidget.vue?vue&type=script&lang=js&"
export * from "./ContactWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports